import produce from "immer";
import { ADDRESS_ACTION_TYPE } from "../actions/address_actions";

const INITIAL_STATE = {
  status: null,
  mapModalOpen: false,
  formModalOpen: false,
  address: {},
};

function Address(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADDRESS_ACTION_TYPE.EDIT:
      return produce(state, (draft) => {
        draft.status = ADDRESS_ACTION_TYPE.EDIT;
        draft.mapModalOpen = true;
        draft.formModalOpen = true;
        draft.address = action.payload;
      });
    case ADDRESS_ACTION_TYPE.CREATE:
      return produce(state, (draft) => {
        draft.status = ADDRESS_ACTION_TYPE.CREATE;
        draft.mapModalOpen = true;
        draft.formModalOpen = false;
        draft.address = {};
      });
    case ADDRESS_ACTION_TYPE.CLEAR:
      return produce(state, (draft) => {
        draft.status = null;
        draft.mapModalOpen = false;
        draft.formModalOpen = false;
        draft.address = {};
      });
    case ADDRESS_ACTION_TYPE.UPDATE_ADDRESS:
      return produce(state, (draft) => {
        draft.formModalOpen = true;
        draft.address.streetAddress1 = action.payload.streetAddress1;
        draft.address.streetAddress2 = action.payload.streetAddress2;
        draft.address.city = action.payload.city;
        draft.address.country = action.payload.country;
        draft.address.countryArea = action.payload.countryArea;
      });
    case ADDRESS_ACTION_TYPE.UPDATE_LOCATION:
      return produce(state, (draft) => {
        draft.address.location = action.payload;
      });
    case ADDRESS_ACTION_TYPE.CLOSE_FORM_MODAL:
      return produce(state, (draft) => {
        draft.formModalOpen = false;
        draft.address.streetAddress1 = "";
        draft.address.streetAddress2 = "";
        draft.address.postalCode = "";
        draft.address.city = "";
      });
    case ADDRESS_ACTION_TYPE.SUBMIT_FORM_MODAL:
      return produce(state, (draft) => {
        draft.address.streetAddress1 = action.payload.streetAddress1;
        draft.address.streetAddress2 = action.payload.streetAddress2;
        draft.address.postalCode = action.payload.postalCode;
        draft.address.city = action.payload.city;
      });
    default:
      return state;
  }
}

export default Address;
